import { render, staticRenderFns } from "./JflowTranspond.vue?vue&type=template&id=76a37463&"
import script from "./JflowTranspond.vue?vue&type=script&lang=js&"
export * from "./JflowTranspond.vue?vue&type=script&lang=js&"
import style0 from "./JflowTranspond.vue?vue&type=style&index=0&id=76a37463&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports